import React from "react";

/**
 * Soft Petal Electrolysis logo image.
 * Sizes handled by parent via className (e.g., "h-16 md:h-20").
 */
export default function Logo({ className = "h-16 md:h-20 w-auto", priority = false }) {
  return (
    <img
      src="/logo.png"
      alt="Soft Petal Electrolysis"
      width="1290"
      height="517"
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      className={`select-none pointer-events-none ${className}`}
      data-testid="site-logo"
    />
  );
}
